import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Table,
  Button,
  Space,
  Form,
  Input,
  DatePicker,
  Select,
  Col,
  Row,
  ConfigProvider,
  Tooltip,
} from "antd";
import locale from "antd/locale/zh_CN";
import "dayjs/locale/zh-cn";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { getStorageValByKey, STORAGE_KEY } from "../../../utils/storage";
import {
  getMainModuleList,
  getChildModuleList,
  getRoleList,
} from "../../../api/common";
import { getJobList, getBaseUrl } from "../../../api/departmentJob";

const { RangePicker } = DatePicker;
// const { Option } = Select;

const RoleSearchForm = ({ data, setData, handleEdit, handleDelete }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setcount] = useState(1);
  const pageSize = 10; // 每页显示的条数
  const handlePageChange = (page) => {
    // 当页码变化时，更新当前页码状态
    //console.log(page);
    setCurrentPage(page.current);
  };

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dateFormat = "YYYY-MM-DD";
  // 当前时间
  const [pickerValue, setPickerValue] = useState([]);

  const permissionIdList = useRef([]);

  useEffect(() => {
    async function fetchJobList() {
      let input = getInput();

      console.log(input);
      const d = await getJobList(input);
      if (!d || !d.data || !d.data.list) return;
      setData(d.data.list);
      //console.log(d.data);
      setcount(d.data.count);
      //setCurrentPage(d.data.page_no);
    }
    fetchJobList();
  }, [currentPage]);

  // 主模块
  const [mainModuleData, setMainModuleData] = useState([]);
  const [defaultMainModuleKey, setDefaultMainModuleKey] = useState("");

  // 子模块
  const [childModuleData, setChildModuleData] = useState([]);
  const [defaultChildModuleKey, setDefaultChildModuleKey] = useState("");

  // 角色
  const [roleData, setRoleData] = useState([]);
  const [defaultRoleKey, setDefaultRoleKey] = useState("");

  //自然村
  const [countrysideData, setCountrysideData] = useState([]);
  const [defaultCountrysideKey, setDefaultCountrysideKey] = useState("");
  const [countryVisible, setCountryVisible] = useState(false);

  // 获取主模块数据
  useEffect(() => {
    async function fetchMainModuleList() {
      const mainModuleList = [{ id: 0, name: "全部" }];
      const res = await getMainModuleList();
      if (res?.code == 0 && res?.data?.length > 0) {
        mainModuleList.push(...res.data);
      }
      setMainModuleData(mainModuleList);
      setDefaultMainModuleKey(mainModuleList[0].id);
    }

    fetchMainModuleList();

    permissionIdList.current = getStorageValByKey(STORAGE_KEY.permissionList);
  }, []);

  // 选择主模块item
  const onMainModuleItemSelected = useCallback(async (id, option) => {
    const newChildModuleData = [{ id: "0", name: "全部" }];
    const newRoleData = [{ id: "0", name: "全部" }];
    if (id > "") {
      const res = await getChildModuleList({ main_depart_id: id });
      if (res.code == 0 && res.data?.length > 0) {
        newChildModuleData.push(...res.data);
      }
    }

    setDefaultMainModuleKey(id);
    setChildModuleData(newChildModuleData);
    setDefaultChildModuleKey(newChildModuleData[0].id);
    setRoleData(newRoleData);
    setDefaultRoleKey(newRoleData[0].id);
  }, []);

  // 选择子模块
  const onChildModuleItemSelected = useCallback(async (id, option) => {
    const newRoleData = [{ id: "0", name: "全部" }];

    try {
      if (id > "") {
        const res = await getRoleList({ depart_id: id });
        console.log("res+_+_", res);
        if (res.code == 0 && res.data?.length > 0) {
          newRoleData.push(...res.data);
        }
      }
    } catch (error) {
      console.log(error);
    }

    setDefaultChildModuleKey(id);
    setRoleData(newRoleData);
    setDefaultRoleKey(newRoleData[0].id);

    //选择自然村的情况下加载自然村的数据
    const newCountrysideData = [{ id: "0", name: "全部" }];
    setCountryVisible(false);
    if (id == 11) {
      setCountryVisible(true);
      try {
        const resC = await getChildModuleList({ main_depart_id: id }); //自然村数据
        console.log("res+_+_", resC);
        if (resC.code == 0 && resC.data?.length > 0) {
          newCountrysideData.push(...resC.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
    setCountrysideData(newCountrysideData);
    setDefaultCountrysideKey(newCountrysideData[0].id);
  }, []);

  // 选择角色
  const onRoleItemSelected = useCallback((id, option) => {
    setDefaultRoleKey(id);
  }, []);

  // 选择自然村
  const onCountrysideItemSelected = useCallback(async (id, option) => {
    setDefaultCountrysideKey(id);
    const newRoleData = [{ id: "0", name: "全部" }];

    try {
      if (id > "") {
        const res = await getRoleList({ depart_id: id });
        console.log("res+_+_", res);
        if (res.code == 0 && res.data?.length > 0) {
          newRoleData.push(...res.data);
        }
      }
    } catch (error) {
      console.log(error);
    }

    setRoleData(newRoleData);
    setDefaultRoleKey(newRoleData[0].id);
  }, []);

  const hasEditPermission = useCallback(() => {
    return permissionIdList.current?.indexOf("1003002") > -1;
  }, []);

  function getInput() {
    let input = { page_no: currentPage, page_size: pageSize };
    const createTime = applyTimeArr.current; //form.getFieldValue("createTime");
    console.log(createTime);
    if (createTime != undefined) {
      const beginTime = createTime[0];
      const endTime = createTime[1];
      const timeJson = { begin_time: beginTime, end_time: endTime };
      input = { ...input, ...timeJson };
    }

    let departId = defaultChildModuleKey;
    if (defaultCountrysideKey != "" && defaultCountrysideKey != 0) {
      departId = defaultCountrysideKey;
    }

    input = {
      ...input,
      ...{ job_id: defaultRoleKey },
      ...{ department_id: departId },
      ...{ main_department_id: defaultMainModuleKey },
    };
    console.log(input);
    return input;
  }

  const columns = [
    // {
    //   title: '创建人',
    //   dataIndex: 'creator',
    //   key: 'creator',
    //   align: 'center'
    // },
    {
      title: "序号",
      dataIndex: "job_id",
      key: "job_id",
      align: "center",
      with: 20,
    },
    {
      title: "创建时间",
      dataIndex: "ctime",
      key: "ctime",
      align: "center",
    },
    {
      title: "板块",
      dataIndex: "main_depart_name",
      key: "main_depart_name",
      align: "center",
    },
    {
      title: "子板块",
      dataIndex: "second_depart_name",
      key: "second_depart_name",
      align: "center",
    },
    {
      title: "岗位角色",
      dataIndex: "job_name",
      key: "job_name",
      align: "center",
    },
    {
      title: "智慧豆",
      dataIndex: "bean_amount",
      key: "bean_amount",
      align: "center",
    },
    {
      title: "岗位说明",
      dataIndex: "description",
      key: "description",
      align: "center",
      ellipsis: true,
      with: 400,
      render: (description) => (
        <Tooltip placement="topLeft" title={description}>
          {description}
        </Tooltip>
      ),
    },
    {
      title: "操作",
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_, record) => (
        <Space size="middle">
          <a
            style={{
              color: hasEditPermission() ? "" : "#999",
            }}
            onClick={() => {
              if (hasEditPermission()) {
                handleEdit(record);
              }
            }}
          >
            编辑
          </a>
          <a
            style={{
              color: hasEditPermission() ? "" : "#999",
            }}
            onClick={() => {
              if (hasEditPermission()) {
                handleDelete(record, getInput());
              }
            }}
          >
            删除
          </a>
        </Space>
      ),
    },
  ];

  const onCreateClick = () => {
    navigate("/ModuleRoleAdd");
  };
  const onCreateClick_1 = () => {
    navigate("/departAdd");
  };
  const handleSearch = async () => {
    // {
    //   "begin_time": "",
    //   "department_id": 0,
    //   "end_time": "",
    //   "job_id": 0,
    //   "page_no": 0,
    //   "page_size": 0
    // }
    let input = getInput();
    input.page_no = 1;
    console.log(input);
    const d = await getJobList(input);
    setData(d.data.list);
    console.log(d.data);
    setcount(d.data.count);
    goToPage(1);
    //setCurrentPage(d.data.page_no);
  };
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  //下载
  function handleLoad() {
    let token = getStorageValByKey(STORAGE_KEY.token);
    let url =
      getBaseUrl() + "/department/job_detail_list/export?token=" + token + "&";
    let input = "";
    const createTime = applyTimeArr.current; //form.getFieldValue("createTime");
    if (createTime != undefined) {
      const beginTime = createTime[0];
      const endTime = createTime[1];
      const timeJson = { begin_time: beginTime, end_time: endTime };
      input = `begin_time=${beginTime}&end_time=${endTime}`;
    }

    let departId = defaultChildModuleKey;
    if (defaultCountrysideKey != "" && defaultCountrysideKey != 0) {
      departId = defaultCountrysideKey;
    }

    if (input != "") {
      input += "&";
    }
    input += `job_id=${defaultRoleKey}&department_id=${departId}`;

    url += input;
    window.location.href = url;
  }

  //时间的处理
  const applyTimeArr = useRef([]);
  const onApplyTimeChanged = useCallback((timeArr) => {
    applyTimeArr.current = timeArr;
  }, []);

  const onRecentDaysClicked = useCallback((days) => {
    const curDateStr = dayjs().format(dateFormat);
    const daysAgo = dayjs().subtract(days, "day");
    const daysAgoStr = dayjs(daysAgo.$d).format(dateFormat);
    onApplyTimeChanged([daysAgoStr, curDateStr]);

    setPickerValue([
      dayjs(daysAgoStr, dateFormat),
      dayjs(curDateStr, dateFormat),
    ]);
  }, []);

  // const handleLast7Days = () => {
  //   const end = moment().endOf("day");
  //   const start = moment().subtract(7, "days").startOf("day");
  //   //form.setFieldsValue({ createTime: [start, end] });
  //   onApplyTimeChanged([start, end]);
  // };

  // const handleLast30Days = () => {
  //   const end = moment().endOf("day");
  //   const start = moment().subtract(30, "days").startOf("day");
  //   //form.setFieldsValue({ createTime: [start, end] });
  //   onApplyTimeChanged([start, end]);
  // };

  return (
    <div style={{ padding: "20px" }}>
      {permissionIdList.current?.indexOf("1003002") > -1 ? (
        <div style={{ marginBottom: "20px" }}>
          <Button type="primary" onClick={onCreateClick}>
            新建岗位
          </Button>
          <Button
            type="primary"
            onClick={onCreateClick_1}
            style={{ marginLeft: "20px" }}
          >
            新建新手村
          </Button>
        </div>
      ) : null}
      <Form form={form} layout="inline">
        <Row align="left" style={{ marginTop: "10px", marginBottom: "5px" }}>
          <Col>
            <Form.Item label="选择板块：" initialValue="全部">
              <Select
                value={defaultMainModuleKey}
                style={{ width: 180 }}
                fieldNames={{ label: "name", value: "id" }}
                onChange={onMainModuleItemSelected}
                options={mainModuleData}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="选择子版块：" initialValue="全部">
              <Select
                value={defaultChildModuleKey}
                style={{ width: 180 }}
                fieldNames={{ label: "name", value: "id" }}
                onChange={onChildModuleItemSelected}
                options={childModuleData}
              />
            </Form.Item>
          </Col>

          {countryVisible ? (
            <Col>
              <Form.Item label="选择自然村" initialValue="全部">
                <Select
                  value={defaultCountrysideKey}
                  style={{ width: 180 }}
                  fieldNames={{ label: "name", value: "id" }}
                  onChange={onCountrysideItemSelected}
                  options={countrysideData}
                />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
        <Row style={{ marginTop: "10px", marginBottom: "5px" }}>
          <Col>
            <Form.Item label="选择角色：" initialValue="全部">
              <Select
                value={defaultRoleKey}
                style={{ width: 180 }}
                fieldNames={{ label: "name", value: "id" }}
                onChange={onRoleItemSelected}
                options={roleData}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="createTime" label="创建时间">
              <ConfigProvider locale={locale}>
                {/* <RangePicker
                  showTime={{ format: "HH:mm:ss" }}
                  format="YYYY-MM-DD HH:mm:ss"
                  style={{ width: "360px" }}
                /> */}

                <RangePicker
                  format={dateFormat}
                  onChange={(value, dateArr) => {
                    onApplyTimeChanged(dateArr);
                    setPickerValue(value);
                  }}
                  value={pickerValue}
                />
              </ConfigProvider>
            </Form.Item>
          </Col>
          <Button type="link" onClick={() => onRecentDaysClicked(7)}>
            最近七天
          </Button>
          <Button
            type="link"
            style={{ marginLeft: 8 }}
            onClick={() => onRecentDaysClicked(30)}
          >
            最近三十天
          </Button>
        </Row>
      </Form>
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
      >
        <Button type="primary" onClick={handleSearch}>
          筛选
        </Button>
        <Button
          type="text"
          style={{ color: "#0F64FF", marginLeft: 8 }}
          onClick={handleLoad}
        >
          下载列表Excel
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="job_id"
        style={{ textAlign: "center", marginTop: "20px" }}
        pagination={{
          pageSize: pageSize,
          current: currentPage,
          total: count,
          pageSizeOptions: [],
          showSizeChanger: false,
        }}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default RoleSearchForm;
